<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0">Настройки пользователя</h4>
					<div class="page-title-right">
						<ol class="breadcrumb m-0">
							<li class="breadcrumb-item">
								<router-link :to="{path: '/'}">Главная</router-link>
							</li>
							<li class="breadcrumb-item">
								<router-link :to="{path: '/profile'}">Профиль</router-link>
							</li>
							<li class="breadcrumb-item active">Настройки пользователя</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Основные данные</h4>
						<div class="row">
							<div class="col-12">
								<div class="mt-4">
									<form @submit.prevent="onSaveProfileData">
										<div class="row">                                                            
											<div class="col-md-4">
												<div class="mb-3">
													<label class="form-label" for="formrow-user-id-input">ID</label>
													<input type="number" class="form-control" id="formrow-user-id-input" v-model="authModel.userProfile.user_id" disabled />
												</div>
											</div>
											<div class="col-md-8">
												<div class="mb-3">
													<label class="form-label" for="formrow-user-login-input">Логин</label>
													<input type="text" class="form-control" id="formrow-user-login-input" v-model="authModel.userProfile.login" disabled />
												</div>
											</div>
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-email-input">Email</label>
											<input type="email" class="form-control" id="formrow-user-email-input" placeholder="Введите ваш email" v-model="authModel.userProfile.email" disabled />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-tel-input">Номер мобильного телефона</label>
											<input type="text" class="form-control" id="formrow-user-tel-input" placeholder="Введите ваш номер мобильного телефона" v-model="authModel.userProfile.tel" />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-sname-input">Фамилия</label>
											<input type="text" class="form-control" id="formrow-user-sname-input" placeholder="Введите вашу фамилию" v-model="authModel.userProfile.sname" />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-fname-input">Имя</label>
											<input type="text" class="form-control" id="formrow-user-fname-input" placeholder="Введите ваше имя" v-model="authModel.userProfile.fname" />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-lname-input">Отчество</label>
											<input type="text" class="form-control" id="formrow-user-lname-input" placeholder="Введите ваше отчество (если есть)" v-model="authModel.userProfile.lname" />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-gender-select">Пол</label>
											<select class="form-select" id="formrow-user-gender-select" v-model="authModel.userProfile.gender">
												<option selected disabled>Выберите ваш пол</option>
												<option value="1">Мужской</option>
												<option value="2">Женский</option>
											</select>
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-user-iin-input">ИИН</label>
											<input type="text" class="form-control" id="formrow-user-iin-input" placeholder="Введите ваш ИИН" v-model="authModel.userProfile.iin" />
										</div>
										<div class="d-flex flex-wrap gap-3 mt-3">
											<button type="submit" class="btn btn-primary waves-effect waves-light w-md" :disabled="btnSaveProfileDataDisabled">{{btnSaveProfileDataText}}</button>
										</div>
										<div class="alert alert-success mt-3 mb-0" v-if="successSaveProfileData">{{successSaveProfileData}}</div>
										<div class="alert alert-warning mt-3 mb-0" v-if="errorSaveProfileData">{{errorSaveProfileData}}</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Социальные данные</h4>
						<div class="row">
							<div class="col-12">
								<div class="mt-4">
									<form @submit.prevent="onSaveSocialData">
										<div class="mb-3">
											<label class="form-label" for="formrow-social-about-textarea">Ваше описание</label>
											<textarea class="form-control" id="formrow-social-about-textarea" placeholder="Введите ваше описание" v-model="authModel.userProfile.about"></textarea>
										</div>
										<div class="d-flex flex-wrap gap-3 mt-3">
											<button type="submit" class="btn btn-primary waves-effect waves-light w-md" :disabled="btnSaveSocialDataDisabled">{{btnSaveSocialDataText}}</button>
										</div>
										<div class="alert alert-success mt-3 mb-0" v-if="successSaveSocialData">{{successSaveSocialData}}</div>
										<div class="alert alert-warning mt-3 mb-0" v-if="errorSaveSocialData">{{errorSaveSocialData}}</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Сменить Email</h4>
						<div class="row">
							<div class="col-12">
								<div class="mt-4">
									<form @submit.prevent="onChangeEmail">
										<div class="mb-3">
											<label class="form-label" for="formrow-change-email-input">Новый Email</label>
											<input type="text" class="form-control" id="formrow-change-email-input" placeholder="Введите новый email" v-model="email" />
										</div>
										<div class="d-flex flex-wrap gap-3 mt-3">
											<button type="submit" class="btn btn-primary waves-effect waves-light w-md" :disabled="btnChangeEmailDisabled">{{btnChangeEmailText}}</button>
										</div>
										<div class="alert alert-success mt-3 mb-0" v-if="successChangeEmail">{{successChangeEmail}}</div>
										<div class="alert alert-warning mt-3 mb-0" v-if="errorChangeEmail">{{errorChangeEmail}}</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Сменить пароль</h4>
						<div class="row">
							<div class="col-12">
								<div class="mt-4">
									<form @submit.prevent="onChangePassword">
										<div class="mb-3">
											<label class="form-label" for="formrow-change-password1-input">Новый пароль</label>
											<input type="password" class="form-control" id="formrow-change-password1-input" placeholder="Введите новый пароль" autocomplete="new-password" v-model="password1" />
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-change-password2-input">Подтверждение пароля</label>
											<input type="password" class="form-control" id="formrow-change-password2-input" placeholder="Введите новый пароль еще раз" autocomplete="new-password" v-model="password2" />
										</div>
										<div class="d-flex flex-wrap gap-3 mt-3">
											<button type="submit" class="btn btn-primary waves-effect waves-light w-md" :disabled="btnChangePasswordDisabled">{{btnChangePasswordText}}</button>
										</div>
										<div class="alert alert-success mt-3 mb-0" v-if="successChangePassword">{{successChangePassword}}</div>
										<div class="alert alert-warning mt-3 mb-0" v-if="errorChangePassword">{{errorChangePassword}}</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Интерфейс</h4>
						<div class="row">
							<div class="col-12">
								<div class="mt-4">
									<form @submit.prevent="onSaveInterfaceSettings">
										<div class="mb-3">
											<label class="form-label" for="formrow-interface-lang-select">Язык интерфейса</label>
											<select class="form-select" id="formrow-interface-lang-select" v-model="authModel.userSettings.lang">
												<option selected disabled>Выберите язык интерфейса</option>
												<option :value="lang" v-for="(lang, i) in appModel.langs" :key="`lang-${i}`">{{appModel.langsName[lang]}}</option>
											</select>
										</div>
										<div class="mb-3">
											<label class="form-label" for="formrow-interface-theme-select">Тема интерфейса</label>
											<select class="form-select" id="formrow-interface-theme-select" v-model="authModel.userSettings.theme">
												<option selected disabled>Выберите тему интерфейса</option>
												<option value="light">Светлая</option>
												<option value="dark">Тёмная</option>
											</select>
										</div>
										<div class="d-flex flex-wrap gap-3 mt-3">
											<button type="submit" class="btn btn-primary waves-effect waves-light w-md" :disabled="btnSaveInterfaceSettingsDisabled">{{btnSaveInterfaceSettingsText}}</button>
										</div>
										<div class="alert alert-success mt-3 mb-0" v-if="successSaveInterfaceSettings">{{successSaveInterfaceSettings}}</div>
										<div class="alert alert-warning mt-3 mb-0" v-if="errorSaveInterfaceSettings">{{errorSaveInterfaceSettings}}</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'ProfileSettings',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Настройки пользователя | Krasp'});
	},
	data: () => ({
		btnSaveProfileDataText: 'Сохранить изменения',
		btnSaveProfileDataDisabled: false,
		successSaveProfileData: '',
		errorSaveProfileData: '',
		
		btnSaveSocialDataText: 'Сохранить изменения',
		btnSaveSocialDataDisabled: false,
		successSaveSocialData: '',
		errorSaveSocialData: '',
		
		email: '',
		btnChangeEmailText: 'Сменить email',
		btnChangeEmailDisabled: false,
		successChangeEmail: '',
		errorChangeEmail: '',
		
		password1: '',
		password2: '',
		btnChangePasswordText: 'Сменить пароль',
		btnChangePasswordDisabled: false,
		successChangePassword: '',
		errorChangePassword: '',
		
		btnSaveInterfaceSettingsText: 'Сохранить изменения',
		btnSaveInterfaceSettingsDisabled: false,
		successSaveInterfaceSettings: '',
		errorSaveInterfaceSettings: '',
	}),
	methods: {
		async onSaveProfileData(){
			this.btnSaveProfileDataText = 'Сохранение изменений...';
			this.btnSaveProfileDataDisabled = true;
			this.successSaveProfileData = '';
			this.errorSaveProfileData = '';
			
			let res = await this.authModel.doSaveProfileData();
			
			this.btnSaveProfileDataText = 'Сохранить изменения';
			this.btnSaveProfileDataDisabled = false;
			if(res.success){
				//this.$router.push('/');
				this.successSaveProfileData = 'Социальные данные успешно сохранены';
			} else {
				this.errorSaveProfileData = 'Возникла ошибка.'+(res.error ? ' '+res.error : ' Попробуйте еще раз.');
				console.log('save interface settings failed.', res.error);
			}
		},
		async onSaveSocialData(){
			this.btnSaveSocialDataText = 'Сохранение изменений...';
			this.btnSaveSocialDataDisabled = true;
			this.successSaveSocialData = '';
			this.errorSaveSocialData = '';
			
			let res = await this.authModel.doSaveSocialData();
			
			this.btnSaveSocialDataText = 'Сохранить изменения';
			this.btnSaveSocialDataDisabled = false;
			if(res.success){
				//this.$router.push('/');
				this.successSaveSocialData = 'Социальные данные успешно сохранены';
			} else {
				this.errorSaveSocialData = 'Возникла ошибка.'+(res.error ? ' '+res.error : ' Попробуйте еще раз.');
				console.log('save interface settings failed.', res.error);
			}
		},
		async onChangeEmail(){
			this.btnChangeEmailText = 'Смена email...';
			this.btnChangeEmailDisabled = true;
			this.successChangeEmail = '';
			this.errorChangeEmail = '';
			
			let res = await this.authModel.doChangeEmail(this.email);
			
			this.btnChangeEmailText = 'Сменить пароль';
			this.btnChangeEmailDisabled = false;
			if(res.success){
				this.email = '';
				//this.$router.push('/');
				this.successChangeEmail = 'Email успешно изменен';
			} else {
				this.errorChangeEmail = 'Возникла ошибка.'+(res.error ? ' '+res.error : ' Попробуйте еще раз.');
				console.log('change email failed.', res.error);
			}
		},
		async onChangePassword(){
			this.btnChangePasswordText = 'Смена пароля...';
			this.btnChangePasswordDisabled = true;
			this.successChangePassword = '';
			this.errorChangePassword = '';
			
			let res = await this.authModel.doChangePassword(this.password1, this.password2);
			
			this.btnChangePasswordText = 'Сменить пароль';
			this.btnChangePasswordDisabled = false;
			if(res.success){
				this.password1 = '';
				this.password2 = '';
				//this.$router.push('/');
				this.successChangePassword = 'Пароль успешно изменен';
			} else {
				this.errorChangePassword = 'Возникла ошибка.'+(res.error ? ' '+res.error : ' Попробуйте еще раз.');
				console.log('change password failed.', res.error);
			}
		},
		async onSaveInterfaceSettings(){
			this.btnSaveInterfaceSettingsText = 'Сохранение изменений...';
			this.btnSaveInterfaceSettingsDisabled = true;
			this.successSaveInterfaceSettings = '';
			this.errorSaveInterfaceSettings = '';
			
			let res = await this.authModel.doSaveInterfaceSettings();
			
			this.btnSaveInterfaceSettingsText = 'Сохранить изменения';
			this.btnSaveInterfaceSettingsDisabled = false;
			if(res.success){
				//this.$router.push('/');
				this.appModel.setLang(this.authModel.userSettings.lang);
				this.successSaveInterfaceSettings = 'Настройки интерфейса успешно сохранены';
			} else {
				this.errorSaveInterfaceSettings = 'Возникла ошибка.'+(res.error ? ' '+res.error : ' Попробуйте еще раз.');
				console.log('save interface settings failed.', res.error);
			}
		},
	},
	beforeMount(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	computed: {},
	components: {
		//Navbar,
	},
};
</script>